import { atom } from "jotai";

// Drives the set-password form's submit button while the complete-signup POST
// is in flight. Mirrors isProcessingApplicationAtom — the invitation validate
// (a one-shot GET on mount) is represented by the page's own status machine, so
// it needs no fetching atom of its own.
export const isProcessingInvitationAtom = atom(false);
